export enum WorkflowId {
  CreateTask = "project-task-create",
  SendHAQCopyV2 = "haq-send-copy-v2",
  ImportedHAQSendCopy = "imported-haq-send-copy",
  HAAssetManualStatusChange = "ha-asset-manual-state-change",
  SponsorAssetManualStatusChange = "sponsor-asset-manual-state-change",
  SubmitImportedHAQ = "imported-haq-send-copy",
  SubmitHAQResponse = "reliance-haq-response-send-copy-to-ha",
  SubmitHAQResponseV2 = "reliance-haq-response-send-copy-to-ha-v2",
  RelianceSubmitDocument = "pac-reliance-submit-for-documents",
  RelianceProjectChangeStatus = "reliance-project-change-status",
  ChangeHAQDueDate = "change-due-date",
  ProjectInvitationCancellation = "project-invitation-cancellation",
  ProjectInvitationCreation = "project-invitation-creation",
  ProjectInvitationUpdate = "project-invitation-update",
  ProjectInvitationReassignment = "project-invitation-reassignment",
  ECTDManualStatusChange = "submission-sequence-manual-state-change",
  ECTDSubmission = "sequence-send-copy",
  SendUnstructuredDocument = "unstructured-send-copy",
  StructuredDocumentManualStatusChange = "structured-document-manual-state-change",
}
